/**
 * v-image-modal directive.
 *
 * 미리보기 페이지에서 v-html로 렌더된 영역의 <img> 태그 클릭을 위임 처리하여
 * 전역 이미지 모달(App.vue의 b-modal + $EventBus.$on('image-modal'))을 띄운다.
 *
 * 사용:
 *   <div v-image-modal v-html="sanitizedContent"></div>
 *   <div v-image-modal="enabled" v-html="sanitizedContent"></div>
 *
 * 동작 조건:
 *   - binding.value가 false가 아닐 것 (옵트아웃)
 *   - 클릭 대상이 IMG 태그
 *   - 부모에 <a> 태그가 없을 것 (링크 클릭 우선)
 *   - 인쇄(print) 모드가 아닐 것
 */

function isEnabled(binding) {
  // binding.value가 명시적으로 false일 때만 비활성화. 그 외(undefined, true 등)는 활성화.
  return binding.value !== false;
}

export default {
  bind(el, binding, vnode) {
    el._imageModalEnabled = isEnabled(binding);
    el._imageModalHandler = function (event) {
      if (!el._imageModalEnabled) return;

      const target = event.target;
      if (!target || target.tagName !== 'IMG') return;
      if (target.closest('a')) return;

      // 인쇄 모드에서는 모달 동작하지 않음
      if (typeof window !== 'undefined' && window.matchMedia) {
        if (window.matchMedia('print').matches) return;
      }

      const src = target.getAttribute('src');
      if (!src) return;

      const eventBus = vnode.context && vnode.context.$EventBus;
      if (!eventBus) return;

      // 부모 컨테이너의 @click(예: TextBox 편집 모드 진입)이 함께 발화하지 않도록 차단
      event.stopPropagation();
      eventBus.$emit('image-modal', src, true);
    };
    el.addEventListener('click', el._imageModalHandler);
  },
  update(el, binding) {
    // prop 변경(예: enableImageModal toggle)에도 즉시 반영
    el._imageModalEnabled = isEnabled(binding);
  },
  unbind(el) {
    if (el._imageModalHandler) {
      el.removeEventListener('click', el._imageModalHandler);
      el._imageModalHandler = null;
    }
  }
};
